import { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";
import { enablePush, pushPermission, pushSupported } from "@/lib/push";
import { toast } from "sonner";

export function NotificationPrompt() {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported()) return;
    const dismissed = localStorage.getItem("doek_push_dismissed");
    if (pushPermission() === "default" && !dismissed) setShow(true);
    if (pushPermission() === "granted") enablePush().catch(() => {});
  }, []);

  const enable = async () => {
    setBusy(true);
    try {
      await enablePush();
      toast.success("Alerts on — we'll ping you for interests, matches & plans");
      setShow(false);
    } catch (e) {
      if (e.message === "denied") toast.error("Notifications blocked in your browser settings");
      else toast.error("Could not enable alerts");
    } finally { setBusy(false); }
  };

  const dismiss = () => { localStorage.setItem("doek_push_dismissed", "1"); setShow(false); };

  if (!show) return null;
  return (
    <div className="max-w-5xl mx-auto px-5 pt-4" data-testid="push-prompt">
      <div className="glass rounded-2xl p-4 flex items-center gap-4 border-amber-500/30">
        <div className="h-10 w-10 rounded-xl bg-amber-500/20 flex items-center justify-center shrink-0">
          <Bell className="h-5 w-5 text-amber-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm">Never miss a spark</p>
          <p className="text-xs text-emerald-100/60">Get alerts for new interests, when a match is ready to call, and confirmed plans.</p>
        </div>
        <button data-testid="enable-push-btn" onClick={enable} disabled={busy}
          className="btn-gold rounded-full px-4 h-9 text-sm shrink-0">{busy ? "…" : "Turn on"}</button>
        <button onClick={dismiss} className="text-emerald-100/40 hover:text-emerald-100/70 shrink-0"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
